export default "__VITE_ASSET__7284dc58__"